/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useMutation } from '@apollo/client';
import { OPPORTUNITY_SUBMISSION_APPLICATIONS } from '@app/apollo/queries';
import { DELETE_SUBMISSION_APPLICATIONS, INVITE_REVIEWER, REGISTRATION_REMINDER } from '@app/apollo/mutations';
import MutationsStatus from '@molecules/MutationsStatus';
import Autocomplete from '@app/components/molecules/Autocomplete';
import {
  Grid,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Tooltip,
  FormControl,
  Chip,
  Avatar,
  TextField,
} from '@mui/material';
import CustomDialog from '@app/components/molecules/CustomDialog';
import Typography from '@app/components/atoms/Typography';
import { FIELDS_ENUM, EXPORT_TYPES } from '@app/constants';
import { useTranslation } from '@app/config/i18n';
import Spacer from '@app/components/atoms/Spacer';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import IconButton from '@app/components/atoms/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIcon from '@mui/icons-material/Assignment';
import NotificationsIcon from '@mui/icons-material/Notifications';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import { StyledTitle, Section, SectionBox } from './style';
import ApplicationsExport from "../../Applications/ApplicationsExport";
import SubmissionsListTable from './SubmissionsListTable/SubmissionsListTable';

const opportunitySubmissionApplicationsViewer = ({
  opportunity,
  applicationSubmissionFilters,
  tableCols
}) => {
  const { t } = useTranslation(['payment', 'common']);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [bottomSheetData, setBottomSheetData] = useState(null);
  const [pageSize, setPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);

  const [filters, setFilters] = useState({
    q: '',
    sort: {
      field: 'RECENT',
      asc: false,
    },
    status: [],
    registration_status: [],
    payment_status: [],
    author: [],
    title: []
  });

  const [selectedSubmissions, setSelectedSubmissions] = React.useState([]);
  const [modalOpened, setModalOpened] = React.useState(false);
  const [inviteModalOpened, setInviteModalOpened] = React.useState(false);
  const [reviewerInfo, setReviewerInfo] = React.useState([]);
  const [selectedReviewerNames, setSelectedReviewerNames] = React.useState([]);

  const { committee_members } = opportunity;
  const programCommitteeMembers = committee_members;

  const takeFullName = (member) => {
    const fullName = member.filter((el) => el.type === FIELDS_ENUM.TEXT_FIELD)[0].value;
    return fullName;
  };

  const handleOnChangeProgramCommitteeMember = (event, members) => {
    // setReviewerInfo({
    //   name: member.name,
    //   email: member.email,
    // });
    const formattedReviewers = members.map((member) => ({
      name: member.name,
      email: member.email,
    }));
    setReviewerInfo(formattedReviewers);
  };



  const {
    // loading: applicationsLoading,
    data: { opportunitySubmissionApplications } = {},
    refetch: refetchSubmissions,
  } = useQuery(OPPORTUNITY_SUBMISSION_APPLICATIONS, {
    variables: {
      slug: opportunity.slug,
      filters,
      first: pageSize,
      page: currentPage,
    },
  });



  const onChangePage = React.useCallback((page) => {
    const newPage = page + 1;
    setCurrentPage(newPage);
  }, []);

  const handleInviteDialogOpen = () => {
    setInviteModalOpened(true);
  };

  const handleInviteDialogClose = () => {
    setInviteModalOpened(false);
  };

  const handleDialogOpen = () => {
    setModalOpened(true);
  };

  const handleDialogClose = () => {
    setModalOpened(false);
  };

  const handleCompletedInviteReviewers = () => {
    setSelectedSubmissions([]);
    handleInviteDialogClose();
  };

  const handleCompletedRegReminders = () => {
    setSelectedSubmissions([]);
  };

  const [
    inviteReviewerMutation,
    { loading: mutationLoading, error: mutationError, data: mutationData },
  ] = useMutation(INVITE_REVIEWER, {
    onCompleted: handleCompletedInviteReviewers,
  });

  const [registrationReminderMutation, { loading: regMutationLoading, error: regMutationError, data: regMutationData },
  ] = useMutation(REGISTRATION_REMINDER, {
    onCompleted: handleCompletedRegReminders,
  });

  const handleCompletedDeleteSubmission = () => {
    setSelectedSubmissions([]);
    handleDialogClose();
    refetchSubmissions();
  };

  const [
    deleteSubmissionMutation,
    { loading: mutationDeleteLoading, error: mutationDeleteError, data: mutationDeleteData },
  ] = useMutation(DELETE_SUBMISSION_APPLICATIONS, {
    onCompleted: handleCompletedDeleteSubmission,
  });

  const showAssignReviewerFormHandler = (e, data) => {
    setSelectedSubmissions([...data]);
    handleInviteDialogOpen();
    // setShowAssignReviewerForm(true);
  };

  const assignReviewersHandler = () => {
    const selectedIDs = selectedSubmissions.map((submission) => submission.id);
    inviteReviewerMutation({
      variables: {
        // input: {
        //   ...reviewerInfo,
        //   opportunityId: opportunity.id,
        //   applications: selectedIDs,
        // },
        input: reviewerInfo.map((reviewer) => ({
          name: reviewer.name,
          email: reviewer.email,
          opportunityId: opportunity.id,
          applications: selectedIDs,
        })),
      },
    });
    setSelectedReviewerNames([...selectedReviewerNames, reviewerInfo.name]);
  };

  const handleRegistrationReminder = (selected) => {
    // Convert object-based selection to array of IDs
    const selectedIDs = Object.keys(selected);
    registrationReminderMutation({
      variables: {
        input: {
          opportunityId: opportunity.id,
          applications: selectedIDs,
        },
      },
    });
  };

  const deleteSubmissionsHandler = (selected) => {
    const submissions = Object.values(selected);
    setSelectedSubmissions([...submissions]);
    handleDialogOpen();
  };

  const confirmDeletionHandler = () => {
    deleteSubmissionMutation({
      variables: {
        ids: selectedSubmissions.map((submission) => submission.id),
      }
    });
  };

  const handleSendEmail = (selected) => {
    const emails = Object.values(selected).map((submission) => submission.user?.email).filter(Boolean);
    window.location.href = `mailto:${emails.join(',')}`;
  };

  const handleAssignReviewers = (selected) => {
    // Convert object-based selection to array of submission data
    const submissions = Object.values(selected);
    setSelectedSubmissions([...submissions]);
    handleInviteDialogOpen();
  };

  console.log("TABLEcOLS:", tableCols);

  const tableActions = [
    {
      icon: () => {
        // return (
        //     <RoundedButton
        //         sx={{ padding: '10px 20px' }}
        //         variant="outlined"
        //         color="primary"
        //         fullWidth
        //     >
        //         Assign reviewers
        //     </RoundedButton>
        // )
        return (
          <Tooltip disableFocusListener title={t('common:assign_reviewers')}>
            <IconButton
              aria-label={t('common:assign_reviewers')}
              sx={{ color: 'secondary.dark', padding: 0 }}
            >
              <AssignmentIcon />
            </IconButton>
          </Tooltip>
        );
      },
      onClick: showAssignReviewerFormHandler,
    },
    {
      icon: () => {
        // return (
        //     <RoundedButton
        //         sx={{ padding: '10px 20px' }}
        //         variant="outlined"
        //         color="primary"
        //         fullWidth
        //     >
        //         Delete submissions
        //     </RoundedButton>
        // )
        return (
          <Tooltip disableFocusListener title={t('common:delete_submissions')}>
            <IconButton
              aria-label={t('common:delete_submissions')}
              sx={{ color: 'secondary.dark', padding: 0 }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        );
      },
      onClick: deleteSubmissionsHandler,
    },
    {
      icon: () => <ApplicationsExport opportunitySlug={opportunity?.slug} exportType={EXPORT_TYPES.SUBMISSION} />,
      isFreeAction: true,
    },
    (rowData) => ({
      icon: () => {
        const data = [];
        rowData.forEach((el) => data.push(el.user.email));

        return (
          <Tooltip disableFocusListener title={t('common:contact_email')}>
            <IconButton
              href={`mailto:${data.join()}`}
              aria-label={t('common:contact_email')}
              sx={{ color: 'secondary.dark', padding: 0 }}
            >
              <MailOutlineIcon />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    {
      icon: () => {
        return (
          <Tooltip disableFocusListener title={t('common:Send Registration Reminder')}>
            <IconButton
              aria-label={t('common:Send Registration Reminder')}
              sx={{ color: 'secondary.dark', padding: 0 }}
            >
              <NotificationsIcon />
            </IconButton>
          </Tooltip>
        );
      },
      onClick: handleRegistrationReminder,
    },
  ];

  const handleFilterChange = React.useCallback((key, value) => {
    // Check if the filter value actually changed before updating
    const currentValue = filters[key];
    const hasChanged = Array.isArray(currentValue)
      ? JSON.stringify(currentValue) !== JSON.stringify(value)
      : currentValue !== value;

    if (hasChanged) {
      const newFilters = { ...filters, [key]: value };
      setFilters(newFilters);

      // Reset to first page when filter actually changes
      setCurrentPage(1);
    }
  }, [filters]);

  return (
    <>
      <MutationsStatus
        loading={mutationLoading || mutationDeleteLoading || regMutationLoading}
        error={mutationError || mutationDeleteError || regMutationError}
        success={mutationData || mutationDeleteData || regMutationData}
      />

      <Grid container xs={12} marginTop={isMobile ? '3rem' : '6rem'}>
        <Grid item xs={12}>
          {!isMobile && (
            <>
              <StyledTitle>
                <Typography color="secondary" variant="h5">
                  Submissions
                </Typography>
              </StyledTitle>
              <Spacer height="2rem" />
            </>
          )}

          <SubmissionsListTable
            opportunity={opportunity}
            submissionDataArray={opportunitySubmissionApplications?.data}
            paginatorInfo={opportunitySubmissionApplications?.paginatorInfo}
            onPageChange={onChangePage}
            onRowsPerPageChange={setPageSize}
            applicationSubmissionFilters={applicationSubmissionFilters}
            filters={filters}
            onFilterChange={handleFilterChange}
            loading={mutationLoading || mutationDeleteLoading || regMutationLoading}
            onDelete={deleteSubmissionsHandler}
            onSendReminder={handleRegistrationReminder}
            onSendEmail={handleSendEmail}
            onAssignReviewers={handleAssignReviewers}
            tableCols={tableCols}
          />
        </Grid>
        <BottomSheet
          open={!!bottomSheetData}
          onDismiss={() => setBottomSheetData(null)}
          header={<Typography variant="h6">{t('common:sub_papers')}</Typography>}
          style={{ zIndex: 999 }}
        >
          {bottomSheetData && (
            <div>
              {bottomSheetData?.elements?.map((element) => {
                if (
                  element.type === FIELDS_ENUM.TITLE ||
                  element.type === FIELDS_ENUM.MANDATORY_TITLE
                ) {
                  return (
                    <SectionBox>
                      <Section container>
                        <Grid key={element.name} item sm={12}>
                          <Typography variant="h5" color="secondary" gutterBottom>
                            {element.field_name}
                          </Typography>
                          <Typography variant="body1" className="elementValue">
                            {element.value}
                          </Typography>
                        </Grid>
                      </Section>
                    </SectionBox>
                  );
                }

                if (element.type === FIELDS_ENUM.MANDATORY_AUTHORS) {
                  return (
                    <SectionBox>
                      <Section container>
                        <Grid key={element.name} item sm={12}>
                          <Typography variant="h5" color="secondary" gutterBottom>
                            {element.field_name}
                          </Typography>
                          <Typography variant="body1" className="elementValue">
                            {element.child_elements
                              .map((child) => takeFullName(child))
                              .flat()
                              .join(', ')}
                          </Typography>
                        </Grid>
                      </Section>
                    </SectionBox>
                  );
                }

                if (
                  (element.type === FIELDS_ENUM.ABSTRACT ||
                    element.type === FIELDS_ENUM.MANDATORY_ABSTRACT)
                ) {
                  return (
                    <SectionBox>
                      <Section container>
                        <Grid key={element.name} item sm={12}>
                          <Typography variant="h5" color="secondary" gutterBottom>
                            {element.field_name}
                          </Typography>
                          <Typography variant="body1" className="elementValue">
                            {element.value ? (
                              <CheckIcon color="secondary" />
                            ) : (
                              <CloseIcon color="secondary" />
                            )}
                          </Typography>
                        </Grid>
                      </Section>
                    </SectionBox>
                  );
                }

                if (
                  (element.type === FIELDS_ENUM.PAPER ||
                    element.type === FIELDS_ENUM.MANDATORY_PAPER)
                ) {
                  return (
                    <SectionBox>
                      <Section container>
                        <Grid key={element.name} item sm={12}>
                          <Typography variant="h5" color="secondary" gutterBottom>
                            {element.field_name}
                          </Typography>
                          <Typography variant="body1" className="elementValue">
                            {element?.files?.length > 0 ? (
                              <CheckIcon color="secondary" />
                            ) : (
                              <CloseIcon color="secondary" />
                            )}
                          </Typography>
                        </Grid>
                      </Section>
                    </SectionBox>
                  );
                }
                return null;
              })}

              <Spacer height="1rem" />
            </div>
          )}
        </BottomSheet>
      </Grid>

      <CustomDialog
        open={modalOpened}
        onClose={handleDialogClose}
        title={t('applications:delete_applications')}
        cancelButtonText={t('common:cancel')}
        acceptButtonText={t('common:delete')}
        handleConfirm={confirmDeletionHandler}
      >
        <Grid item xs={12}>
          {t('applications:delete_selected')}
        </Grid>
      </CustomDialog>

      <CustomDialog
        open={inviteModalOpened}
        onClose={handleInviteDialogClose}
        title={t('applications:invite_reviewers')}
        cancelButtonText={t('common:cancel')}
        acceptButtonText={t('common:send_invites')}
        handleConfirm={assignReviewersHandler}
        maxWidth="md"
        fullWidth
      >
        <Grid item xs={12}>
          <Spacer height="1rem" />
          <Autocomplete
            multiple
            options={programCommitteeMembers}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.email === value.email}
            getOptionDisabled={(option) =>
              reviewerInfo.some((r) => r.email === option.email)
            }
            id="committee_members"
            name="committee_members"
            disableCloseOnSelect
            value={reviewerInfo}
            onChange={handleOnChangeProgramCommitteeMember}
            sx={{ marginLeft: '1rem', width: '90%' }}
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  key={option.email}
                  label={option.name}
                  avatar={<Avatar>{option.name.charAt(0)}</Avatar>}
                  sx={{
                    backgroundColor: '#E3F2FD',
                    color: '#0D47A1',
                    margin: '2px',
                    fontWeight: 500,
                  }}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Select the committee member from this dropdown list"
                placeholder="Select reviewers"
              />
            )}
          />
        </Grid>
      </CustomDialog>
    </>
  );
};

opportunitySubmissionApplicationsViewer.propTypes = {
  opportunity: PropTypes.object.isRequired,
  applicationSubmissionFilters: PropTypes.object,
  tableCols: PropTypes.array
};

opportunitySubmissionApplicationsViewer.defaultProps = {
  applicationSubmissionFilters: {},
};

export default opportunitySubmissionApplicationsViewer;
